module.exports = __webpack_public_path__ + "img/wechat-bg.5e1ade22.jpg";